import Inputmask from 'inputmask';

jQuery(document).ready(function () {
    const block = jQuery('.pay-block');
    if (!block.get(0)) return;
    const form = block.find('form');
    const form_elements = form.find('input,select');
    const submit_button = form.find('.pay-form__submit');
    const customer_idp_field_response = form.find('[data-customer-idp-response]');
    const customer_id_field = form.find('[name="Customer_IDP"]');
    const subtotal_p_field = form.find('[name="Subtotal_P"]');

    let form_state = 0;

    initFormFieldsMask();
    form.on('input', onInputFormPay);
    form.on('submit', onSubmitFormPay);

    function initFormFieldsMask() {
        const mask = new Inputmask({ mask: '9', repeat: '*' });
        mask.mask(customer_id_field.get(0));
        mask.mask(subtotal_p_field.get(0));
    }

    function onInputFormPay() {
        const required_elements = form_elements.filter('[required]');
        const error = Boolean(
            required_elements.filter((key, input) => !input.value || jQuery(input).is(':invalid')).length
        );

        if (error) {
            submit_button.attr('disabled', 'disabled');
        } else {
            submit_button.removeAttr('disabled');
        }
    }

    function onSubmitFormPay() {
        if (!form_state) {
            form_state = 1;

            const form_data = new FormData(this);

            jQuery.ajax({
                url: '/wp-admin/admin-ajax.php',
                dataType: 'json',
                data: {
                    action: 'payment',
                    job: form_data.get('job'),
                    Subtotal_P: form_data.get('Subtotal_P'),
                    Customer_IDP: form_data.get('Customer_IDP')
                },

                beforeSend() {
                    form.addClass('loading');
                    customer_idp_field_response.text('');
                },

                success(data) {
                    const fields = data?.data ?? {};

                    if (Object.keys(fields).length) {
                        jQuery.each(fields, (key, val) => {
                            if (key.charAt(0) === '.') {
                                key = key.slice(1);
                            }

                            form.find(`[name='${key}']`).val(val);
                        });

                        form_state = 2;
                        form.submit();
                    }
                },

                error(xhr, _status, error) {
                    customer_idp_field_response.text(xhr?.responseJSON?.data || error);
                },

                complete() {
                    form.removeClass('loading');
                    form_state = 0;
                }
            });
            return false;
        }

        if (form_state === 1) {
            return false;
        }

        return true;
    }
});
